const PolygonShape = ({ shapeId, elementProperties = {} }) => {
  const {
    isTransparent,
    strokeWidth,
    backgroundColor,
    borderColor,
    strokeUnit,
    opacity = 100,
  } = elementProperties;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      id={shapeId}
      style={{ opacity: opacity / 100 }}
    >
      <polygon
        id={shapeId}
        points="50,0 100,50 50,100 0,50"
        fill={isTransparent ? "none" : backgroundColor}
        stroke={borderColor}
        strokeWidth={`${strokeWidth}${strokeUnit}`}
      />
    </svg>
  );
};

export default PolygonShape;
